import ajax from "../utils/request";

const CheckRewardApi = {
  /********************************金刚区配置列表*********************************** */
  // 获取金刚区列表
  list(params) {
    return ajax({
      url: "/checkrewards/list",
      type: "post",
      params: params,
    });
  },
  save(param) {
    return ajax({
      url: "/checkrewards/add",
      type: "post",
      params: param,
    });
  },
  update(param) {
    return ajax({
      url: "/checkrewards/update",
      type: "post",
      params: param,
    });
  },
  remove(param) {
    return ajax({
      url: "/checkrewards/del",
      type: "post",
      params: param,
    });
  },
  copy(param) {
    return ajax({
      url: "/checkrewards/copy",
      type: "post",
      params: param,
    });
  },
  field(param) {
    return ajax({
      url: "/checkrewards/field",
      type: "post",
      params: param,
    });
  },
};

export default CheckRewardApi;
